import axios from 'axios';

const EMPLOYEE_API_BASE_URL = 'https://bunnyrent-backend-917484933271.us-central1.run.app/api';

const employeeApi = axios.create({
  baseURL: EMPLOYEE_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

employeeApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('employee_access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default employeeApi; 